import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { performLogout } from '../../utils/logoutHandler';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import './sidebar.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/'; // Fallback for undefined API_URL
console.log('API_URL =>', API_URL); // Debugging

const ThirdSidebar = () => {
  const { t } = useTranslation('sidebar');
  // Consolidate useAuth calls
  const { tprmUser, caraUser, caraAdmin, tprmUseruser } = useAuth();
  console.log('tprmUser =>', tprmUser?.user_type);
  console.log('caraUser =>', caraUser?.user_type);
  console.log('caraAdmin =>', caraAdmin?.user_type);
  console.log('tprmUseruser =>', tprmUseruser?.user_type);

  const [isHovered, setIsHovered] = useState(false);
  const [user, setUser] = useState(null); // Store user data
  const [activeItem, setActiveItem] = useState(''); // Track active menu item

  // Determine dashboard link based on user type
  const dashboardLink = tprmUser?.user_type === '14' || tprmUseruser?.user_type === '19'
    ? '/tprm_admin_dashboard'
    : '/assessment_dashboard';

  // Handle menu item click to set active state
  const handleMenuClick = (item) => {
    setActiveItem(item);
  };

  // Search functionality
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const $ = window.$;
    // Search functionality - filter menu items
    const searchValue = searchTerm.toLowerCase().trim();
    if (searchValue) {
      // Find and scroll to matching menu items (including those in collapsed submenus)
      const menuItems = document.querySelectorAll('.nav-link p, .nav-link');
      let foundMatch = false;
      let firstMatch = null;

      menuItems.forEach((item) => {
        const text = item.textContent?.toLowerCase() || '';
        if (text.includes(searchValue)) {
          const navItem = item.closest('.nav-item');
          if (navItem) {
            // Check if this item is inside a collapsed submenu
            const parentTreeview = navItem.closest('.has-treeview');
            if (parentTreeview && !parentTreeview.classList.contains('menu-open')) {
              // Use jQuery to expand the parent menu (same as manual expansion)
              const $parent = $(parentTreeview);
              const $submenu = $parent.find('> .nav-treeview');

              // Close all other open menus first (like manual expansion does)
              $('.has-treeview.menu-open').not($parent)
                .removeClass('menu-open menu-is-opening')
                .find('> .nav-treeview')
                .css('display', 'none');

              // Open the current menu
              $parent.addClass('menu-open menu-is-opening');
              $submenu.css('display', 'block');
            }

            // Store first match for scrolling
            if (!foundMatch) {
              firstMatch = navItem;
            }

            foundMatch = true;
          }
        }
      });

      if (foundMatch && firstMatch) {
        // Scroll to the first match after menu expansion
        setTimeout(() => {
          const sidebar = document.querySelector('.sidebar');
          if (sidebar && firstMatch) {
            const itemTop = firstMatch.offsetTop;
            const sidebarScrollTop = sidebar.scrollTop;
            const sidebarHeight = sidebar.clientHeight;

            // Calculate scroll position to center the item
            const scrollTo = itemTop - (sidebarHeight / 2) + (firstMatch.offsetHeight / 2);

            // Smooth scroll the sidebar container instead of using scrollIntoView
            sidebar.scrollTo({
              top: scrollTo,
              behavior: 'smooth'
            });

            // Highlight the matching item
            firstMatch.classList.add('highlight-search');
            setTimeout(() => {
              firstMatch.classList.remove('highlight-search');
            }, 2000);
          }
        }, 150); // Wait for menu expansion animation
      } else if (!foundMatch) {
        // Optional: Show a message if no matches found
        console.log('No matches found');
      }
    }
  };

  // Treeview toggle logic with jQuery
  useEffect(() => {
    const $ = window.$;

    $('.sidebar').off('click.treeview').on('click.treeview', '.has-treeview > a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      const parent = $(this).parent();
      const submenu = parent.find('> .nav-treeview');
      const isOpen = parent.hasClass('menu-open');

      if (isOpen) {
        parent.removeClass('menu-open menu-is-opening');
        submenu.css('display', 'none');
      } else {
        $('.has-treeview.menu-open')
          .not(parent)
          .removeClass('menu-open menu-is-opening')
          .find('> .nav-treeview')
          .css('display', 'none');
        parent.addClass('menu-open menu-is-opening');
        submenu.css('display', 'block');
      }
    });

    return () => {
      $('.sidebar').off('click.treeview');
    };
  }, []);

  // Fetch user name

  // Fetch user details
  useEffect(() => {
    axios
      .get(`${API_URL}api/userr-detail/`, { withCredentials: true })
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        console.error('Error fetching user details:', error);
      });
  }, []);

  const handleLogout = async () => {
    try {
      // Use centralized logout handler for immediate cross-tab synchronization
      const userType = tprmUser?.user_type || tprmUseruser?.user_type || caraUser?.user_type;
      const role = tprmUser?.role_name || tprmUseruser?.role_name || caraUser?.role_name;
      await performLogout(userType, role);
      toast.success(t('msg.logoutSuccess', { defaultValue: 'User logged out successfully' }));
    } catch (error) {
      console.error('Logout Error:', error);
      toast.error(`Logout Error: ${error.message}`);
      // Even on error, force logout
      window.location.href = '/login';
    }
  };

  return (
    <div className="cara-sidebar-root" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {/* Styles moved to sidebar.css */}
      {/* Main Sidebar Container */}
      <aside
        id="mainSidebar"
        className="main-sidebar sidebar-dark-primary elevation-4"
        data-bs-theme="dark"
      >
        {/* Brand Logo Section */}
        <a href={(caraUser?.role_name || "").toLowerCase().trim() === "internal auditor" ? "/internal_auditor_dashboard" : (caraUser?.role_name || "").toLowerCase().trim() === "external auditor" ? "/external_auditor_dashboard" : "/assessment_dashboard"} className="d-flex align-items-center m-3">
          <img
            src={isHovered ? "../img/cyberinsurify_logo.png" : "../img/cyberinsurify-logo-small.png"}
            alt="CyberInsurify Logo"
            className={`logo-small brand-image ${isHovered ? 'hovered' : ''}`}
          />
          <span className="brand-text font-weight-light">

            <img
              src={isHovered ? "../img/cyberinsurify_logo.png" : "../img/cyberinsurify_logo.png"}
              alt="CyberInsurify Logo"
              className="brand-logo ml-4"
            />
          </span>

        </a>
        {/* Brand Name */}
        <h6 className="fw-300 ml-2">{t('brand.tprmModule', { defaultValue: 'CARA 2.0 - TPRM Module' })}</h6>

        {/* Sidebar */}
        <div className="sidebar sidebar-font sidebar-scroll">
          <nav className="mt-2">
            {/* Search Bar Section */}
            <form onSubmit={handleSearch} className="input-group mb-3 sidebar-search">
              <input
                type="text"
                className="form-control search-input"
                placeholder={t('menu.search', { defaultValue: 'Search...' })}
                aria-label={t('aria.sidebarSearch', { defaultValue: 'Sidebar search' })}
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-outline-secondary square-btn"
                  type="submit"
                  aria-label={t('aria.searchButton', { defaultValue: 'Search' })}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </form>

            <ul className="nav nav-pills nav-sidebar flex-column text-left" data-widget="treeview" role="menu" data-accordion="false">
              {/* Dashboard Section */}
              {(caraUser?.user_type !== '15' && caraUser?.user_type !== '16') || caraUser?.user_type === '2' || caraAdmin?.user_type === '1' ? (
                <li className="nav-item has-treeview">
                  <a href="#" className={`nav-link ${activeItem === 'dashboard' ? 'active' : ''}`} onClick={() => handleMenuClick('dashboard')}>
                    <img src="../img/dashboard-icon.png" alt="Dashboard Icon" className="icon-style me-2" />
                    <p>
                      {t('menu.dashboardHeading', { defaultValue: 'Dashboard' })}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href={dashboardLink} className={`nav-link ${activeItem === 'assessments' ? 'active' : ''}`} onClick={() => handleMenuClick('assessments')}>
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.dashboard.assessments', { defaultValue: 'Assessments Dashboard' })}</p>
                      </a>
                    </li>
                    {tprmUser?.user_type !== '14' && tprmUseruser?.user_type !== '19' && (
                      <>
                        <li className="nav-item">
                          <a
                            href="./tprm_dashboard"
                            className={`nav-link ${activeItem === 'tprm' ? 'active' : ''}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => handleMenuClick('tprm')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.dashboard.tprm', { defaultValue: 'TPRM Dashboard' })}</p>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            href="./crq_dashboard"
                            className={`nav-link d-flex flex-column align-items-start position-relative ${activeItem === 'crq' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('crq')}
                          >
                            <span className="badge bg-primary text-light mb-1 badge-beta">
                              {t('badge.beta', { defaultValue: 'Beta' })}
                            </span>
                            <div className="d-flex align-items-center">
                              <img src="../img/sub-icon.png" className="sub-icon me-2" />
                              <p className="mb-0">{t('menu.dashboard.crq', { defaultValue: 'CRQ Dashboard' })}</p>
                            </div>
                          </a>
                        </li>
                      </>
                    )}
                    {tprmUseruser?.user_type !== '19' && (
                      <li className="nav-item">
                        <a
                          href="./crp_dashboard"
                          className={`nav-link ${activeItem === 'resilience' ? 'active' : ''}`}
                          onClick={() => handleMenuClick('resilience')}
                        >
                          <img src="../img/sub-icon.png" className="sub-icon me-2" />
                          <p>{t('menu.dashboard.crp', { defaultValue: 'Resilience Posture Dashboard' })}</p>
                        </a>
                      </li>
                    )}
                  </ul>
                </li>
              ) : null}

              {/* Auditor Dashboard for caraUser type 16 */}
              {caraUser?.user_type === '16' && (
                <li className="nav-item has-treeview">
                  <a href="#" className={`nav-link ${activeItem === 'auditor_dashboard' ? 'active' : ''}`} onClick={() => handleMenuClick('auditor_dashboard')}>
                    <img src="../img/dashboard-icon.png" alt="Dashboard Icon" className="icon-style me-2" />
                    <p>
                      {t('menu.dashboardHeading', { defaultValue: 'Dashboard' })}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a
                        href="./auditor_dashboard"
                        className={`nav-link ${activeItem === 'auditor' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('auditor')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.dashboard.auditor', { defaultValue: 'Auditor Dashboard' })}</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./crp_dashboard"
                        className={`nav-link ${activeItem === 'resilience_auditor' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('resilience_auditor')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.dashboard.crp', { defaultValue: 'Resilience Posture Dashboard' })}</p>
                      </a>
                    </li>
                  </ul>
                </li>
              )}

              {/* Compliance Operations */}
              {tprmUser?.user_type !== '14' && tprmUseruser?.user_type !== '19' && (
                <li className="nav-item has-treeview">
                  <a
                    href="#"
                    className={`nav-link ${activeItem === 'compliance' ? 'active' : ''}`}
                    onClick={() => handleMenuClick('compliance')}
                  >
                    <img src="../img/risk-management.png" alt="Risk Management Icon" className="icon-style me-2" />
                    <p>
                      {t('menu.compliance', { defaultValue: 'Compliance Operations' })}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link
                        to="/framework_and_standards"
                        className={`nav-link ${activeItem === 'frameworks' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('frameworks')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.compliance.frameworks', { defaultValue: 'Frameworks and Standards' })}</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link
                        to="/archived_frameworks"
                        className={`nav-link ${activeItem === 'archived_frameworks' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('archived_frameworks')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>Archived Frameworks</p>
                      </Link>
                    </li> */}
                    {caraUser?.user_type === '16' && (
                      <li className="nav-item">
                        <Link
                          to="/questionnaire"
                          className={`nav-link ${activeItem === 'questionnaire_compliance' ? 'active' : ''}`}
                          onClick={() => handleMenuClick('questionnaire_compliance')}
                        >
                          <img src="../img/sub-icon.png" className="sub-icon me-2" />
                          <p>{t('menu.tprm.questionnaire', { defaultValue: 'Questionnaire' })}</p>
                        </Link>
                      </li>
                    )}
                    <li className="nav-item">
                      <a
                        href="./index2.html"
                        className={`nav-link ${activeItem === 'assets' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('assets')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.compliance.assets', { defaultValue: 'Asset Management' })}</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./compliance_tracker"
                        className={`nav-link ${activeItem === 'compliance_tracker' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('compliance_tracker')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.compliance.tracker', { defaultValue: 'Compliance Tracker' })}</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./progress_tracker"
                        className={`nav-link ${activeItem === 'progress_tracker' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('progress_tracker')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.compliance.progress', { defaultValue: 'Progress Tracker' })}</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="./evidence_tracker"
                        className={`nav-link ${activeItem === 'evidence_tracker' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('evidence_tracker')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.compliance.evidence', { defaultValue: 'Evidence Tracker' })}</p>
                      </a>
                    </li>
                  </ul>
                </li>
              )}

              {/* Request Management for caraUser type 15 */}
              {caraUser?.user_type === '15' && (
                <li className="nav-item">
                  <a
                    href="./request_management"
                    className={`nav-link ${activeItem === 'request_management' ? 'active' : ''}`}
                    onClick={() => handleMenuClick('request_management')}
                  >
                    <img src="../img/risk-management.png" alt="Risk Management Icon" className="icon-style me-2" />
                    <p>{t('menu.requestManagement', { defaultValue: 'Request Management' })}</p>
                  </a>
                </li>
              )}

              {/* TPRM Questionnaire for tprmUser types 14 or 19 */}
              {(tprmUser?.user_type === '14' || tprmUseruser?.user_type === '19') && (
                <li className="nav-item has-treeview">
                  <a
                    href="#"
                    className={`nav-link ${activeItem === 'tprm_questionnaire' ? 'active' : ''}`}
                    onClick={() => handleMenuClick('tprm_questionnaire')}
                  >
                    <img src="../img/risk-management.png" alt="Risk Management Icon" className="icon-style me-2" />
                    <p>
                      {t('menu.tprmQuestionnaireHeading', { defaultValue: 'TPRM Questionnaire' })}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link
                        to="/tprm_tracker"
                        className={`nav-link ${activeItem === 'tprm_tracker' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('tprm_tracker')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.tprm.tracker', { defaultValue: 'TPRM Tracker' })}</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/tprm_v2_questionnaire"
                        className={`nav-link ${activeItem === 'tprm_v2_questionnaire' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('tprm_v2_questionnaire')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.tprm.assessments', { ns: 'tprm_v2_questionnaire', defaultValue: 'My Questionnaires' })}</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* Risk Management */}
              {caraUser?.user_type !== '16' && caraUser?.user_type !== '15' && (
                <li className="nav-item has-treeview">
                  <a
                    href="#"
                    className={`nav-link ${activeItem === 'risk_management' ? 'active' : ''}`}
                    onClick={() => handleMenuClick('risk_management')}
                  >
                    <img src="../img/risk-icon.png" alt="Risk Icon" className="icon-style me-2" />
                    <p>
                      {t('menu.riskManagement', { defaultValue: 'Risk Management' })}
                      <i className="fas fa-angle-left right" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    {/* <li className="nav-item">
                      <a
                        href="/risk_dashboard"
                        className={`nav-link ${activeItem === 'risk_dashboard' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('risk_dashboard')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>Risk Dashboard</p>
                      </a>
                    </li> */}
                    <li className="nav-item">
                      <a
                        href={tprmUser?.user_type === '14' || tprmUseruser?.user_type === '19' ? '/upgrade' : '/cara_roi_quantifier'}
                        className={`nav-link ${activeItem === 'roi_quantifier' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('roi_quantifier')}
                      >
                        <span className="badge bg-primary text-light mb-1 badge-beta">
                          {t('badge.beta', { defaultValue: 'Beta' })}
                        </span>
                        <div className="d-flex align-items-center">
                          <img src="../img/sub-icon.png" className="sub-icon me-2" />
                          <p>{t('menu.risk.roi', { defaultValue: 'CARA ROI Quantifier' })}</p>
                        </div>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={tprmUser?.user_type === '14' || tprmUseruser?.user_type === '19' ? '/upgrade' : '/risk_register'}
                        className={`nav-link ${activeItem === 'risk_register' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('risk_register')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.riskManagement.enterpriseRegister', { defaultValue: 'Enterprise Risk Register' })}</p>
                      </a>
                    </li>
                    {tprmUser?.user_type !== '14' && tprmUseruser?.user_type !== '19' && (
                      <>
                        <li className="nav-item">
                          <a
                            href="./risk_register_tracker"
                            className={`nav-link ${activeItem === 'risk_register_tracker' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('risk_register_tracker')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.riskManagement.tracker', { defaultValue: 'Risk Register Tracker' })}</p>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            href="./risk_assessment"
                            className={`nav-link ${activeItem === 'risk_assessment' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('risk_assessment')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.riskManagement.assessments', { defaultValue: 'Risk Assessments' })}</p>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            href="./risk_assesment_tracker"
                            className={`nav-link ${activeItem === 'risk_assessment_tracker' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('risk_assessment_tracker')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.risk.assessmentTracker', { defaultValue: 'Risk Assessments Tracker' })}</p>
                          </a>
                        </li>
                      </>
                    )}
                  </ul>
                </li>
              )}

              {/* Audit Management */}
              <li className="nav-item has-treeview">
                <a
                  href="#"
                  className={`nav-link ${activeItem === 'audit_management' ? 'active' : ''}`}
                  onClick={() => handleMenuClick('audit_management')}
                >
                  <span className="sidebar-icons">
                    <img src="../img/audit-icon.svg" className="icon-style me-2" />
                  </span>
                  <p>
                    {t('menu.audit', { defaultValue: 'Audit Management' })}
                    <i className="fas fa-angle-left right" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to={tprmUser?.user_type === '14' || tprmUseruser?.user_type === '19' ? '/upgrade' : '/manage_audit'}
                      className={`nav-link ${activeItem === 'manage_audits' ? 'active' : ''}`}
                      onClick={() => handleMenuClick('manage_audits')}
                    >
                      <img src="../img/sub-icon.png" className="sub-icon me-2" />
                      <p>{t('menu.audit.manage', { defaultValue: 'Manage Audits' })}</p>
                    </Link>
                  </li>
                  {tprmUser?.user_type !== '14' && tprmUseruser?.user_type !== '19' && (
                    <>
                      <li className="nav-item">
                        <a
                          href="./audit_checklist"
                          className={`nav-link ${activeItem === 'audit_checklist' ? 'active' : ''}`}
                          onClick={() => handleMenuClick('audit_checklist')}
                        >
                          <img src="../img/sub-icon.png" className="sub-icon me-2" />
                          <p>{t('menu.audit.checklist', { defaultValue: 'Audit Checklist' })}</p>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="./audit_documents"
                          className={`nav-link ${activeItem === 'audit_documents' ? 'active' : ''}`}
                          onClick={() => handleMenuClick('audit_documents')}
                        >
                          <img src="../img/sub-icon.png" className="sub-icon me-2" />
                          <p>{t('menu.audit.documents', { defaultValue: 'Audit Documents' })}</p>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="./audit_tracker"
                          className={`nav-link ${activeItem === 'audit_tracker' ? 'active' : ''}`}
                          onClick={() => handleMenuClick('audit_tracker')}
                        >
                          <img src="../img/sub-icon.png" className="sub-icon me-2" />
                          <p>{t('menu.audit.tracker', { defaultValue: 'Audit Tracker' })}</p>
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </li>

              {/* Third Party Management */}
              {(caraUser?.user_type !== '16' && caraUser?.user_type !== '15') || caraAdmin?.user_type === '1' ? (
                <li className="nav-item has-treeview">
                  <a
                    href="#"
                    className={`nav-link ${activeItem === 'third_party' ? 'active' : ''}`}
                    onClick={() => handleMenuClick('third_party')}
                  >
                    <span className="sidebar-icons">
                      <img src="../img/third-party-icon.png" className="icon-style me-2" />
                    </span>
                    <p>
                      {t('menu.tprmMgmt', { defaultValue: 'Third Party Risk Mgmt' })}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    {tprmUser?.user_type !== '14' && tprmUseruser?.user_type !== '19' && (
                      <li className="nav-item">
                        <Link
                          to="/questionnaire"
                          className={`nav-link ${activeItem === 'questionnaire_third_party' ? 'active' : ''}`}
                          onClick={() => handleMenuClick('questionnaire_third_party')}
                        >
                          <img src="../img/sub-icon.png" className="sub-icon me-2" />
                          <p>{t('menu.tprm.questionnaire', { defaultValue: 'Questionnaire' })}</p>
                        </Link>
                      </li>
                    )}
                    <li className="nav-item">
                      <Link
                        to={tprmUser?.user_type === '14' || tprmUseruser?.user_type === '19' ? '/upgrade' : '/third_party_users'}
                        className={`nav-link ${activeItem === 'third_party_users' ? 'active' : ''}`}
                        onClick={() => handleMenuClick('third_party_users')}
                      >
                        <img src="../img/sub-icon.png" className="sub-icon me-2" />
                        <p>{t('menu.tprm.users', { defaultValue: 'Third Party Users' })}</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              ) : null}

              {/* User Management */}
              {caraUser?.user_type !== '16' && tprmUseruser?.user_type !== '19' && (
                <li className="nav-item has-treeview">
                  <a
                    href="#"
                    className={`nav-link ${activeItem === 'user_management' ? 'active' : ''}`}
                    onClick={() => handleMenuClick('user_management')}
                  >
                    <span className="sidebar-icons">
                      <img src="../img/user-icon.svg" className="icon-style me-2" />
                    </span>
                    <p>
                      {t('menu.userManagement', { defaultValue: 'User Management' })}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    {tprmUser?.user_type !== '14' && tprmUseruser?.user_type !== '19' && (
                      <>
                        <li className="nav-item">
                          <Link
                            to="/role_management"
                            className={`nav-link ${activeItem === 'role_management' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('role_management')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.userManagement.roles', { defaultValue: 'Role Management' })}</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/department_management"
                            className={`nav-link ${activeItem === 'department_management' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('department_management')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.userManagement.departments', { defaultValue: 'Department Management' })}</p>
                          </Link>
                        </li>
                      </>
                    )}
                    {tprmUseruser?.user_type !== '19' && (
                      <>
                        <li className="nav-item">
                          <Link
                            to={tprmUser?.user_type === '14' ? '/cara_tprm_user_details' : '/my_users'}
                            className={`nav-link ${activeItem === 'my_users' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('my_users')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.userManagement.users', { defaultValue: 'My Users' })}</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/audit_trail_user"
                            className={`nav-link ${activeItem === 'audit_trail_user' ? 'active' : ''}`}
                            onClick={() => handleMenuClick('audit_trail_user')}
                          >
                            <img src="../img/sub-icon.png" className="sub-icon me-2" />
                            <p>{t('menu.audit.trail', { defaultValue: 'Audit Trail' })}</p>
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </li>
              )}

              {/* Cyber Resilience Posture */}
              {caraUser?.user_type !== '15' && (
                <li className="nav-item">
                  <Link
                    to="/cyber_resilience_posture"
                    className={`nav-link ${activeItem === 'cyber_resilience' ? 'active' : ''}`}
                    onClick={() => handleMenuClick('cyber_resilience')}
                  >
                    <img src="../img/cyber-icon.svg" className="icon-style me-2" />
                    <p>{t('menu.cyberResilience', { defaultValue: 'Cyber Resilience Posture' })}</p>
                  </Link>
                </li>
              )}



              {/* Ask the Expert */}
              <li className="nav-item">
                <Link
                  to="/ask_the_expert"
                  className={`nav-link ${activeItem === 'ask_expert' ? 'active' : ''}`}
                  onClick={() => handleMenuClick('ask_expert')}
                >
                  <span className="sidebar-icons">
                    <img src="../img/ask-expert-icon.png" className="icon-style me-2" />
                  </span>
                  <p>{t('menu.support.expert', { defaultValue: 'Ask the Expert' })}</p>
                </Link>
              </li>

              {/* Feedback and Suggestions */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link">
                  <span className="sidebar-icons">
                    <img
                      src="../img/feedback-icon.png"
                      className="icon-style me-2"
                    />
                  </span>
                  <p>
                    {t('menu.support.feedback', { defaultValue: 'Feedback & Suggestions' })}
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to="/submit_feedback" className="nav-link">
                      <img
                        src="/img/sub-icon.png"
                        className="sub-icon me-2"
                      />
                      <p>{t('menu.feedback.submit', { defaultValue: 'Submit Feedback' })}</p>
                    </Link>
                  </li>

                  {caraUser?.user_type !== "16" && (
                    <li className="nav-item">
                      <Link to="/my_feedback" className="nav-link">
                        <img
                          src="../img/sub-icon.png"
                          className="sub-icon me-2"
                        />
                        <p>{t('menu.feedback.my', { defaultValue: 'My Feedback' })}</p>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              {/* Resources */}
              <li className="nav-item has-treeview">
                <a
                  href="#"
                  className={`nav-link ${activeItem === 'resources' ? 'active' : ''}`}
                  onClick={() => handleMenuClick('resources')}
                >
                  <img src="../img/resources-icon.svg" className="icon-style me-2" />
                  <p>
                    {t('menu.resources', { defaultValue: 'Resources' })}
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <a
                      href="https://caragrc.com/blog/"
                      className={`nav-link ${activeItem === 'blog' ? 'active' : ''}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => handleMenuClick('blog')}
                    >
                      <img src="../img/sub-icon.png" className="sub-icon me-2" />
                      <p>{t('menu.resources.blog', { defaultValue: 'CARA Blog' })}</p>
                    </a>
                  </li>
                </ul>
              </li>

              {/* My Settings */}
              <li className="nav-item has-treeview">
                <a
                  href="#"
                  className={`nav-link ${activeItem === 'settings' ? 'active' : ''}`}
                  onClick={() => handleMenuClick('settings')}
                >
                  <span className="sidebar-icons">
                    <img src="../img/settings-icon.svg" className="icon-style me-2" />
                  </span>
                  <p>
                    {t('menu.settings', { defaultValue: 'My Settings' })}
                    <i className="right fas fa-angle-left" />
                  </p>
                </a>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to="/privacy"
                      className={`nav-link ${activeItem === 'privacy' ? 'active' : ''}`}
                      onClick={() => handleMenuClick('privacy')}
                    >
                      <img src="../img/sub-icon.png" className="sub-icon me-2" />
                      <p>{t('menu.settings.privacy', { defaultValue: 'Privacy' })}</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/profile"
                      className={`nav-link ${activeItem === 'profile' ? 'active' : ''}`}
                      onClick={() => handleMenuClick('profile')}
                    >
                      <img src="../img/sub-icon.png" className="sub-icon me-2" />
                      <p>{t('menu.settings.profile', { defaultValue: 'Profile' })}</p>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Logout Section */}
              <li className="nav-item mb-3">
                <button
                  className="nav-link d-flex align-items-center logout-btn"
                  onClick={() => {
                    Swal.fire({
                      title: t('menu.logoutConfirmTitle', { defaultValue: 'Are you sure?' }),
                      text: t('menu.logoutConfirmText', { defaultValue: 'You will be logged out of your session!' }),
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: t('menu.logoutConfirmBtn', { defaultValue: 'Yes, logout!' }),
                      background: '#fff',
                      color: '#333'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        handleLogout();
                      }
                    });
                  }}
                >
                  <span className="sidebar-icons">
                    <img
                      src="../img/logout-icon.png"
                      className="icon-style me-2"
                      alt="logout-icon"
                    />
                  </span>
                  <p className="mb-0">
                    {t('menu.logout', { defaultValue: 'Logout' })}
                    <span className="logout-username">
                      {tprmUseruser?.first_name || tprmUser?.first_name} {tprmUseruser?.last_name || tprmUser?.last_name}
                    </span>
                  </p>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default ThirdSidebar;
